import Button from "react-bootstrap/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

import useCustomTranslation from "core/customTranslation";
import ConditionalRender from "../ConditionalRender";

const translations = {
    es: {
        title: "Ubicación GPS",
        "title.device": "Ubicación GPS (dispositivo)",
        "title.asset": "Ubicación GPS (Contenedor)",
        notData: "No hay coordenadas disponibles para el dispositivo.",
        lat: "Latitud",
        lng: "Longitud",
        action: "Editar Ubicación",
    },
    en: {
        title: "GPS Location",
        "title.device": "GPS Location (device)",
        "title.asset": "GPS Location (Container)",
        notData: "No coordinates available for the device.",
        lat: "Latitude",
        lng: "Longitude",
        action: "Edit Location",
    },
};

const ItemExpected = {
    lat: 0,
    lng: 0,
    uuid: "",
    uid: "",
};

const CoordinatesInputs = ({item = ItemExpected, handleChange = () => {}, handleModalMap = null}) => {
    const {t: _T} = useCustomTranslation(translations);

    const getFallback = () => {
        return (
            <div className="card p-3 mb-3">
                <h6 className="card-title">{_T("title")}</h6>
                <div className="row">
                    <div className="col-12 mt-2">
                        <small className="text-muted">{_T("notData")}</small>
                    </div>
                </div>
            </div>
        );
    };

    const getTitle = () => {
        if (item.uuid) {
            return _T("title.device") + ` UUID: ${item.uuid}`;
        } else {
            return _T("title.asset") + ` UID: ${item.uid}`;
        }
    };

    return (
        <ConditionalRender condition={item.lat && item.lng} fallback={getFallback()}>
            <div className="card p-3">
                <h6 className="card-title">{getTitle()}</h6>
                <div className="row align-items-end">
                    <div className="col-5">
                        <label htmlFor="lat" className="form-label small">
                            {_T("lat")}
                        </label>
                        <input
                            type="number"
                            max="90"
                            min="-90"
                            className="form-control text-end"
                            id="lat"
                            name="lat"
                            step="any"
                            value={item.lat || ""}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-5">
                        <label htmlFor="lng" className="form-label small">
                            {_T("lng")}
                        </label>
                        <input
                            type="number"
                            max="90"
                            min="-90"
                            step="any"
                            className="form-control text-end"
                            id="lng"
                            name="lng"
                            value={item.lng || ""}
                            onChange={handleChange}
                        />
                    </div>
                    <div className="col-2 mt-3 text-end">
                        <ConditionalRender condition={handleModalMap}>
                            <Button title={_T("action")} variant="outline-primary" type="button" onClick={() => handleModalMap()}>
                                <FontAwesomeIcon icon="fa-map-location-dot" />
                            </Button>
                        </ConditionalRender>
                    </div>
                </div>
            </div>
        </ConditionalRender>
    );
};

export default CoordinatesInputs;
